import { Edit, HomeTwoTone } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISupportCase, LabelValue, PermissionKeys, useHasPermission, Widget } from '../../../shared';
import { useAddressFormatter } from '../../formatters';
import { UpdateResidenceModal } from '../update-residence-modal/update-residence-modal.component';

export const Residence: FC<{ supportCase: ISupportCase }> = ({ supportCase }) => {
    const { t } = useTranslation();

    const [showAddressModal, setShowAddressModal] = useState(false);
    const { hasPermission } = useHasPermission();
    const hasWritePermission = hasPermission(PermissionKeys.SUPPORT_CASES_WRITE);

    const { address } = supportCase;
    const addressText = useAddressFormatter(supportCase.address);
    const mappedAddress = {
        ...address,
        street: address.street || '',
        number: address.number || '',
        box: address.box || '',
        postalCode: address.postalCode || '',
        city: address.city || '',
        country: address.country || '',
        livingSituation: supportCase.livingSituation,
        familySituation: supportCase.familySituation,
    };

    return (
        <Widget
            icon={<HomeTwoTone color="primary" />}
            title={t('residence')}
            actions={
                hasWritePermission && (
                    <IconButton onClick={() => setShowAddressModal(true)} data-testid="edit-address">
                        <Edit />
                    </IconButton>
                )
            }
        >
            <Stack spacing={1}>
                <LabelValue
                    label={t('familySituation')}
                    value={
                        (supportCase.familySituation ? t(supportCase.familySituation) : '') ||
                        t('emptyStateFamilySituation')
                    }
                />

                <LabelValue
                    label={t('livingSituation')}
                    value={
                        (supportCase.livingSituation ? t(supportCase.livingSituation) : '') ||
                        t('emptyStateLivingSituation')
                    }
                />

                <LabelValue
                    label={t('addressLabel')}
                    value={
                        !address.postalCode && !address.street ? (
                            t('emptyStateAddress')
                        ) : (
                            <span data-testid="address">{addressText}</span>
                        )
                    }
                />
            </Stack>

            <UpdateResidenceModal
                open={showAddressModal}
                supportCaseId={supportCase.id}
                address={mappedAddress}
                handleClose={() => setShowAddressModal(false)}
            />
        </Widget>
    );
};
